// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ifsRn","input":"styles_input__2JPXQ"};